const githubLink="https://github.com/FirebrowserDevs/FireBrowser-Uwp";
const discord="https://discord.gg/kYStRKBHwy";
const emailLink="mailto:firebrowserdevs@gmail.com";

const profileLinks={
    githubLink,
    discord,
    emailLink
}
const SocialData=profileLinks;
export default SocialData;

